import { render, staticRenderFns } from "./LoadScreen.vue?vue&type=template&id=49ba03bc&"
import script from "./LoadScreen.vue?vue&type=script&lang=ts&"
export * from "./LoadScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ba03bc')) {
      api.createRecord('49ba03bc', component.options)
    } else {
      api.reload('49ba03bc', component.options)
    }
    module.hot.accept("./LoadScreen.vue?vue&type=template&id=49ba03bc&", function () {
      api.rerender('49ba03bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadScreen.vue"
export default component.exports